const stats = [
  { icon: "ri-fire-line", label: "热议话题", value: "9 条" },
  { icon: "ri-time-line", label: "最近整理", value: "2026.10" },
  { icon: "ri-question-answer-line", label: "常见问答", value: "6 问" },
];

const anchors = [
  { href: "#profile", label: "个人资料速览", icon: "ri-id-card-line" },
  { href: "#updates", label: "近况动态", icon: "ri-radar-line" },
  { href: "#topics", label: "八卦话题", icon: "ri-chat-3-line" },
  { href: "#social", label: "社交动态", icon: "ri-instagram-line" },
];

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full min-h-[640px] lg:min-h-[720px] flex flex-col">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20atmospheric%20background%20with%20soft%20warm%20terracotta%20rose%20and%20champagne%20gradient%20waves%2C%20delicate%20flowing%20silk%20texture%2C%20artistic%20stylized%20cinematic%20lighting%2C%20no%20recognizable%20faces%2C%20refined%20editorial%20mood%2C%20deep%20rich%20tones&width=1920&height=1080&seq=saeko-hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 w-full flex-1 flex flex-col pt-16">
        {/* 更新条压顶 */}
        <div className="bg-foreground-950/45 backdrop-blur border-b border-background-50/15">
          <div className="w-full px-4 md:px-8 py-2.5 flex items-center gap-3 flex-wrap">
            <span className="flex items-center gap-2 text-background-100 text-xs md:text-sm font-label">
              <span className="relative w-2 h-2 flex items-center justify-center">
                <span className="absolute w-2 h-2 rounded-full bg-accent-400 animate-pulse-dot"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
              </span>
              更新条
            </span>
            <span className="text-background-200/90 text-xs md:text-sm">
              本期新增 3 条话题 · 最近整理于 2026 年 10 月
            </span>
            <span className="hidden sm:inline text-background-300/70 text-xs">·</span>
            <span className="hidden sm:inline text-background-300/80 text-xs">
              内容为公开信息与网络讨论整理，仅供参考
            </span>
          </div>
        </div>

        <div className="flex-1 w-full px-4 md:px-8 py-14 md:py-20 flex flex-col justify-center">
          <div className="max-w-4xl">
            <p className="font-label text-accent-300 text-xs md:text-sm tracking-[0.3em] mb-4">
              近况 · 八卦 · 个人资料 · 绯闻 · INS
            </p>
            <h1 className="font-heading font-black text-background-50 text-4xl md:text-6xl leading-tight mb-6 animate-fade-up">
              松下纱荣子近况与个人资料全览
            </h1>
            <p className="text-background-100/90 text-base md:text-lg leading-relaxed max-w-2xl mb-8">
              这里把关于松下纱荣子的热门信息集中到一页：她是谁、近期讨论度为什么回升、网上流传的年龄与绯闻说法该怎么看、社交平台动态又有哪些话题。
              不必在多个页面之间来回跳转，一页就能把主要焦点浏览一遍。
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-10">
              <a
                href="#profile"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-sm px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-down-circle-line text-lg" aria-hidden="true"></i>
                从个人资料开始看
              </a>
              <a
                href="#topics"
                className="inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 font-label text-sm px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg" aria-hidden="true"></i>
                直接看热议八卦
              </a>
            </div>

            <div className="flex flex-wrap gap-x-6 gap-y-3">
              {stats.map((s) => (
                <div key={s.label} className="flex items-center gap-2.5">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-background-50/15 text-accent-300">
                    <i className={`${s.icon} text-base`} aria-hidden="true"></i>
                  </span>
                  <span className="font-label text-background-200 text-xs">
                    {s.label}
                    <span className="ml-1 text-background-50 font-bold">{s.value}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-8 pb-8">
          <div className="flex flex-wrap gap-2.5">
            {anchors.map((a) => (
              <a
                key={a.href}
                href={a.href}
                className="inline-flex items-center gap-2 bg-background-50/90 hover:bg-background-50 text-foreground-900 font-label text-xs md:text-sm px-4 py-2 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={`${a.icon} text-base text-primary-600`} aria-hidden="true"></i>
                {a.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}